module.exports = __webpack_public_path__ + "components/weather-icon/static/nightclear-0b61893943aeea8c3bc20bb4fcf21c0c.svg";